import {NodeSelection, TextSelection} from 'prosemirror-state';
import {
  chainCommands,
  deleteSelection,
  joinForward,
  selectNodeForward,
} from 'prosemirror-commands';

import 'fomantic-ui-less/definitions/modules/transition.less';
import 'fomantic-ui-less/definitions/modules/dropdown.less';

import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/dropdown';
import {safeSlugify} from '../helper/safeSlugify';
import {DOMSerializer} from 'prosemirror-model';

const isLevelSelectedNumber = selection => level => level >= selection;
const isLevelSelectedArray = selection => level => selection.includes(level);

const isLevelSelected = levels => Array.isArray(levels)
    ? isLevelSelectedArray(levels)
    : isLevelSelectedNumber(levels);

const headings2ast = view => {
  const ast = {l: 0, n: '', pos: 0, c: []};
  const stack = [ast];

  view.state.doc.descendants((docNode, pos) => {
    if (docNode.type === view.state.schema.nodes.heading) {
      const keyHtml = DOMSerializer.fromSchema(view.state.schema).serializeNode(docNode);
      const key = keyHtml?.innerHTML || docNode.textContent;

      const node = {
        l: docNode.attrs.level,
        n: key,
        pos,
        c: [],
      };

      if (node.l > stack[0].l) {
        stack[0].c.push(node);
        stack.unshift(node);
      } else if (node.l === stack[0].l) {
        stack[1].c.push(node);
        stack[0] = node;
      } else {
        while (node.l <= stack[0].l) {
          stack.shift();
        }
        stack[0].c.push(node);
        stack.unshift(node);
      }
    }
  });

  return ast;
};

const ast2html = (tree, levels) => {
  if (!tree) {
    return;
  }

  if (tree.c.length === 0) {
    return '';
  }

  let buffer = '';
  if (tree.l === 0 || isLevelSelected(levels)(tree.l)) {
    buffer += '<ul>';
  }
  tree.c.forEach(node => {
    if (isLevelSelected(levels)(node.l)) {
      buffer += `<li><a href="#${safeSlugify(node.n)}-${node.pos}">${node.n}</a>${ast2html(node, levels)}</li>`;
    } else {
      buffer += ast2html(node, levels);
    }
  });
  if (tree.l === 0 || isLevelSelected(levels)(tree.l)) {
    buffer += '</ul>';
  }
  return buffer;
};

const createToc = (view, node, callback) => {
  const toc = document.createElement('div');
  toc.className = 'table-of-contents';

  toc.insertAdjacentHTML('beforeend', ast2html(headings2ast(view), node.attrs.levels));
  toc.addEventListener('click', e => callback(e));
  toc.addEventListener('refresh-table-of-contents', () => {
    toc.querySelector('ul')?.remove();
    toc.insertAdjacentHTML('beforeend', ast2html(headings2ast(view), node.attrs.levels));
  });
  return toc;
}

export default class TableOfContentsNodeView {
  constructor(node, view, getPos) {
    this.viewDom = createToc(view, node, () => this.handleClick());
    this.view = view;
    this.getPos = getPos;
    this.node = node;
    this.dom = document.createElement('div');
    this.dom.appendChild(this.viewDom);
  }

  selectNode() {
    if (!this.view.editable) {
      return;
    }

    this.viewDom.classList.add('selected');

    if (this.editorDom) {
      return;
    }

    const nodePos = this.getPos();
    const editorSegment = document.createElement('div');
    editorSegment.classList.add('ui', 'segment', 'form');
    editorSegment.insertAdjacentHTML('beforeend', `<div class="field required"><label for="levels-${nodePos}">Heading levels</label><select id="levels-${nodePos}" name="levels" multiple="" class="ui fluid dropdown">
        <option value="1"${this.node.attrs.levels.includes(1) ? ' selected' : ''}>1</option>
        <option value="2"${this.node.attrs.levels.includes(2) ? ' selected' : ''}>2</option>
        <option value="3"${this.node.attrs.levels.includes(3) ? ' selected' : ''}>3</option>
        <option value="4"${this.node.attrs.levels.includes(4) ? ' selected' : ''}>4</option>
        <option value="5"${this.node.attrs.levels.includes(5) ? ' selected' : ''}>5</option>
        <option value="6"${this.node.attrs.levels.includes(6) ? ' selected' : ''}>6</option>
        </select></div></div>`);

    this.editorDom = document.createElement('div');
    this.editorDom.id = `editor-table-of-contents-${this.getPos()}`;
    this.editorDom.className = 'ui raised segments transition hidden';
    this.editorDom.appendChild(editorSegment);

    const {bottom: viewBottom} = this.viewDom.getBoundingClientRect();
    const {bottom: boxBottom} = this.view.dom.getBoundingClientRect();
    this.editorDom.style.top = 8 + viewBottom - boxBottom + "px";

    this.view.dom.parentNode.appendChild(this.editorDom);

    $(this.editorDom).transition({
      animation: 'scale',
      duration: 0
    });

    const settingsForm = $(editorSegment).form({
      inline: true,
      duration: 0,
      fields: {
        [`levels-${nodePos}`]: 'minCount[1]'
      }
    });

    const dropdown = $(editorSegment.querySelectorAll('.ui.dropdown')).dropdown({
      duration: 0
    });

    const saveSettings = e => {
      e.preventDefault();

      settingsForm.form('validate form');
      if (!settingsForm.form('is valid')) {
        return;
      }

      const transaction = this.view.state.tr.setNodeMarkup(this.getPos(), undefined, {
        levels: dropdown.dropdown('get value').map(v => parseInt(v))
      });
      this.view.dispatch(transaction);
      this.view.focus();
    }

    const closeEditor = () => {
      const $pos = this.view.state.doc.resolve(this.getPos());
      const transaction = this.view.state.tr.setSelection(TextSelection.near($pos));
      this.view.dispatch(transaction);
      this.view.focus();
    }

    const okButton = document.createElement('button');
    okButton.id = `ok-${this.dom.id}`;
    okButton.className = 'ui tiny compact button primary';
    okButton.textContent = 'Save';
    okButton.addEventListener("click", saveSettings);

    const cancelButton = document.createElement('button');
    cancelButton.id = `cancel-${this.dom.id}`;
    cancelButton.className = 'ui tiny compact button';
    cancelButton.textContent = 'Cancel';
    cancelButton.addEventListener("click", closeEditor);

    const removeButton = document.createElement('button');
    removeButton.id = `remove-${this.dom.id}`;
    removeButton.className = 'ui tiny compact button';
    removeButton.textContent = 'Remove';
    removeButton.addEventListener("click", () => {
      chainCommands(deleteSelection, joinForward, selectNodeForward)(this.view.state, this.view.dispatch);
      this.view.focus();
    });

    const buttonsGroup = document.createElement('div');
    buttonsGroup.className = 'ui wrapping spaced buttons';
    buttonsGroup.appendChild(okButton);
    buttonsGroup.appendChild(document.createTextNode('\u00A0'));
    buttonsGroup.appendChild(cancelButton);
    buttonsGroup.appendChild(document.createTextNode('\u00A0'));
    buttonsGroup.appendChild(removeButton);

    const buttonsSegment = document.createElement('div');
    buttonsSegment.className = 'ui secondary segment';
    buttonsSegment.appendChild(buttonsGroup);

    this.editorDom.appendChild(buttonsSegment);
  }

  deselectNode() {
    if (!this.view.editable) {
      return;
    }

    this.viewDom.classList.remove('selected');

    if (this.editorDom) {
      this.editorDom.remove();
      delete this.editorDom;
    }
  }

  ignoreMutation() {
    return true;
  }

  handleClick() {
    if (!this.view.editable) {
      return;
    }

    const $pos = this.view.state.doc.resolve(this.getPos());
    const transaction = this.view.state.tr.setSelection(new NodeSelection($pos));
    this.view.dispatch(transaction);
  }

  stopEvent(e) {
    if (/key/.test(e.type)) {
      return true;
    } else if (this.view.editable && this.editorDom && /drag/.test(e.type)) {
      this.editorDom.remove();
      delete this.editorDom;
    }
  }

  destroy() {
    this.deselectNode();
    this.dom.remove();
    delete this.dom;
  }
}